import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from '@/stores/authStore';

import { messagesApi } from '../api/messages';

export function useOrgThread(studentId: string, enabled: boolean) {
  return useQuery({
    queryKey: ['messages', 'org', studentId],
    queryFn: () => messagesApi.orgThread(studentId),
    enabled,
    refetchInterval: 15_000,
  });
}

export function useStudentThread() {
  const hasRole = useAuthStore((s) => s.hasRole);
  return useQuery({
    queryKey: ['messages', 'student'],
    queryFn: messagesApi.studentThread,
    enabled: hasRole('student'),
    refetchInterval: 15_000,
  });
}

export function useOrgInbox() {
  return useQuery({
    queryKey: ['messages', 'org', 'inbox'],
    queryFn: messagesApi.inbox,
    refetchInterval: 30_000,
  });
}

export function useSendMessage(invalidateKey: unknown[]) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: messagesApi.send,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: invalidateKey });
      qc.invalidateQueries({ queryKey: ['messages', 'org', 'inbox'] });
    },
  });
}
